import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)

Vue.config.productionTip = false

Vue.filter('dateFormat', function (datetime, fmt) {
  if (datetime === '' || datetime == null) {
    return ''
  } else {
    const date = new Date(datetime)
    let ret
    const opt = {
      'Y+': date.getFullYear().toString(), // 年
      'm+': (date.getMonth() + 1).toString(), // 月
      'd+': date.getDate().toString(), // 日
      'H+': date.getHours().toString(), // 时
      'M+': date.getMinutes().toString(), // 分
      'S+': date.getSeconds().toString() // 秒
      // 有其他格式化字符需求可以继续添加，必须转化成字符串
    }
    for (const k in opt) {
      ret = new RegExp('(' + k + ')').exec(fmt)
      if (ret) {
        fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')))
      };
    };
    return fmt
  }
})

document.oncontextmenu = function () {
  return false
}
// document.addEventListener('touchmove', ev => {
//   ev.preventDefault()
// }, { passive: false })
// document.addEventListener('mousemove', ev => {
//   ev.preventDefault()
// }, { passive: false })

// router.beforeEach((to, from, next) => {
//   console.log(123);

//   let href = window.location.href;
//   console.log(href);
//   if (href.includes("web/?code")) { //url包括 com/?code 证明为从微信跳转回来的
//     //var url = href.substring(0, href.length - 2); //vue自动在末尾加了 #/ 符号，截取去掉
//     href = href.replace('#/', '&');
//     var jingPosit = href.indexOf("?code"); //获取域名结束的位置
//     console.log(jingPosit)
//     var urlLeft = href.substring(0, jingPosit); //url左侧部分
//     var urlRight = href.substring(jingPosit, href.length); //url右侧部分
//     window.location = urlLeft + "#/" + urlRight; //拼接跳转
//     console.log('code');
//   }
//   // 逻辑操作
// })


new Vue({
  router,
  store,
  //vuetify,
  render: h => h(App)
}).$mount('#app')
